import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useMemo } from 'react';
import { AnalyticsListener as AnalyticsListenerAnalyticsNext } from '@atlaskit/analytics-next';
import { extractAWCDataFromEvent, OPERATIONAL_EVENT_TYPE, TRACK_EVENT_TYPE } from '@atlassian/analytics-bridge';
import { initialiseErrorAnalyticsClient } from '@atlassian/error-handling';
import { UI_MODIFICATIONS_ANALYTICS_CHANNEL } from '../../constants';

// Copied from platform/packages/data/error-handling/src/utils/fire-error-analytics.tsx as this is the type they expect
// It should be AnalyticsListener (from @atlassiansox/analytics-web-client), but this type was not available at the time fire-error-analytics was created

export var sendEvent = function sendEvent(event, client) {
  switch (event.type) {
    case OPERATIONAL_EVENT_TYPE:
      Promise.resolve(client).then(function (c) {
        return c.sendOperationalEvent(event);
      });
      break;
    case TRACK_EVENT_TYPE:
      Promise.resolve(client).then(function (c) {
        return c.sendTrackEvent(event);
      });
      break;
  }
};
export var getEventHandler = function getEventHandler(analyticsWebClient) {
  return function (event) {
    var eventData = extractAWCDataFromEvent(event);
    sendEvent(_objectSpread({
      type: eventData.type
    }, eventData.payload), analyticsWebClient);
  };
};
export var AnalyticsListener = function AnalyticsListener(_ref) {
  var children = _ref.children,
    analyticsWebClient = _ref.analyticsWebClient;
  var onEvent = useMemo(function () {
    return getEventHandler(analyticsWebClient);
  }, [analyticsWebClient]);
  useEffect(function () {
    var initClient = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var client;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return analyticsWebClient;
            case 2:
              client = _context.sent;
              initialiseErrorAnalyticsClient(client);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function initClient() {
        return _ref2.apply(this, arguments);
      };
    }();
    initClient();
  }, [analyticsWebClient]);
  return /*#__PURE__*/React.createElement(AnalyticsListenerAnalyticsNext, {
    onEvent: onEvent,
    channel: UI_MODIFICATIONS_ANALYTICS_CHANNEL
  }, children);
};